export function isSystemField(namespace: string) {
  return namespace === 'standard' || namespace === 'system' || namespace.startsWith('Extension');
}

export function sanitizeName(name: string): string {
  return (name || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^0-9a-z\-_]/g, '');
}
